/**
 * TanStack Query hooks for `automatic-let-s-encrypt-renewal-not-manual-ticket`.
 * Thin wrappers over ./api. Invalidates list on any mutation.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	forceRenewCert,
	letsEncryptQueryKeys,
	listCerts,
	registerDomain,
	type ListCertsResponse,
	type RegisterDomainBody,
	type RegisterDomainResponse,
	type RenewCertResponse,
} from "./api";

export function useLetsEncryptCertList(): UseQueryResult<
	ListCertsResponse,
	Error
> {
	return useQuery({
		queryKey: letsEncryptQueryKeys.list(),
		queryFn: listCerts,
	});
}

export function useRegisterLetsEncryptDomain(): UseMutationResult<
	RegisterDomainResponse,
	Error,
	RegisterDomainBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: registerDomain,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: letsEncryptQueryKeys.all });
		},
	});
}

export function useForceRenewLetsEncryptCert(): UseMutationResult<
	RenewCertResponse,
	Error,
	number
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: forceRenewCert,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: letsEncryptQueryKeys.all });
		},
	});
}
